/*
 * Module for the New Benefits Estimate page
*/
rs.module("ui/content/communications/onlineforms/withholdingdecision",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var withholdingDecisionRadio = stepContainer.js(jsSelectors.withholdingDecisionRadio, { multiple: true });
            var withholdingDecisionDescriptionDiv = stepContainer.js(jsSelectors.withholdingDecisionDescriptionDiv, { multiple: true });

            var selectedIndex = withholdingDecisionRadio.index(withholdingDecisionRadio.filter(":checked"));
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedWithholdingDecisionDescription(selectedIndex);
            }

            // Handle the withholdingDecisionRadio click event
            withholdingDecisionRadio.on("click", function () {

                var selectedIndex = withholdingDecisionRadio.index(this);
                showSelectedWithholdingDecisionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected withholding decision
            function showSelectedWithholdingDecisionDescription(selectedIndex) {

                // Close all quickly
                withholdingDecisionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                withholdingDecisionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);